import {
  Component,
  OnInit,
  NgZone,
  ChangeDetectorRef,
  AfterViewInit,
  LOCALE_ID,
  Inject,
  PLATFORM_ID
} from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { seoManagement } from "../../models/seo/seoClass";
import { Meta, Title } from "@angular/platform-browser";
import { SEO } from "../../models/seo/seoInterface";
import { LinkService } from "../../../app/service/link.service";
import { isPlatformBrowser } from "@angular/common";
import { Content } from "@angular/compiler/src/render3/r3_ast";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent extends seoManagement
  implements OnInit, SEO, AfterViewInit {
  image: string;
  title;
  Title;
  description;
  img;
  url;
  currentPage;
  PLATFORM_ID;
  categories = [];
  slider = [];
  height;
  currentImage = {
    path: "",
    index: -1
  };

  curentIndex = -1;
  SliderInterval;
  afterLoad: Boolean = false;
  homename: any;
  home: any;
  CurrentlangId: string;
  constructor(
    public titleService: Title,
    public metaService: Meta,
    private _facadeService: FacadeService,
    private _NgZone: NgZone,
    private _cdr: ChangeDetectorRef,
    public link: LinkService,
    @Inject(LOCALE_ID) local,
    @Inject(PLATFORM_ID) private platfromId
  ) {
    super(
      titleService,
      metaService,
      isPlatformBrowser(platfromId),
      local,
      link
    );
    this.currentLangId = local;
  }

  ngOnInit() {
    this.setSeoTagsProperties();
    this.getAllCatogeries();
    this.getSlider();
  }

  ngAfterViewInit() {
    this.afterLoad = true;
  }

  /**
   * request all site catogeries from api
   */
  getAllCatogeries() {
    this._facadeService.Product.categories.subscribe(res => {
      this.categories = res.data;
    });
  }

  /**
   * get all slider images from api
   */
  getSlider() {
    this._facadeService.Product.slider.subscribe(res => {
      this.slider = res.data;
      this.startSlider();
    });
  }

  /**
   * start slider intervel and set frist image
   */
  startSlider() {
    this.SetCurrentImage();
    // save interval id
    this._NgZone.runOutsideAngular(() => {
      this.SliderInterval = setInterval(() => {
        this.SetCurrentImage();
        this._cdr.detectChanges();
      }, 5000);
    });
  }
  // set current image
  SetCurrentImage() {
    const startedIndex = this.nextSLideIndex();
    this.currentImage.path = this.slider[startedIndex];
    this.currentImage.index = startedIndex;
  }

  /**
   * get next slide index and handel end index case
   */
  nextSLideIndex() {
    this.curentIndex += 1;

    if (this.curentIndex > this.slider.length - 1) {
      this.curentIndex = 0;
    }

    if (this.curentIndex == this.slider.length) {
      return 0;
    }

    return this.curentIndex;
  }

  /**
   * view slide number  @param i
   */
  viesSlide(i) {
    // stop slider intervel from work
    clearInterval(this.SliderInterval);
    // start slider added one to current silder
    this.curentIndex = i - 1;

    // start slider intervel
    this.startSlider();
  }

  setSeoTagsProperties() {
    const currentUrlLang = this.currentLangId === "en" ? "" : "ar/";
    if (this.CurrentlangId === "ar") {
      this.title = "نيو فرنتشر للاثاث المكتبي ";
      this.description =
        "نيو فرنتشر بتوفرلك جميع الأنواع والمقأسات المختلفة  بأفضل جودة وأرخص الأسعار";
    } else {
      this.title = "New Furniture Egypt Office Furniture Company";
      this.description =
        "New furniture provides for you all the different types and sizes of  with the best quality and least prices.";
    }
    this.url = "https://www.newfurniture-eg.com/" + currentUrlLang;
    this.link.addTag({
      rel: "",
      href: this.url
    });

    this.setSeoTags(this.title, this.description, this.image, this.url);
  }
}
